export enum MarketType {
    Spot,
    Futures
  }
  